import { jsx } from 'panel';
import { SvgIconEl } from 'common/components/svg-icon';
export function template() {
  return jsx("div", {
    class: {
      'create-annotations-button-container': true,
      active: this.isAttributeEnabled("active")
    }
  }, jsx(SvgIconEl, {
    attrs: {
      icon: "plus"
    }
  }));
}